















import Vue from "vue";
import ProjectsList from "@/components/ProjectsList.vue";
import freeToolsData from "@/data/FreeToolsData.ts";

export default Vue.extend({
  name: "FreeTools",
  components: {
    ProjectsList,
  },
  data: function () {
    return {
      projects: freeToolsData,
    };
  },
});
